import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  UserSubOrder1EnrichedStatusEnum,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../../../../../global-config'
import {
  userSubOrderAccessorIsMarketplaceOrder,
  userSubOrderAccessorIsSubOrderReturnable,
} from '../../../../../order'
import {
  urlResolverGetHelpWithMyOrderBySubOrderId,
  urlResolverGetOrderQuestionsReturnItemPage,
  urlResolverGetRefundOrder,
} from '../../../../../url-handling'

export const orderQuestionSelfServiceAccessorGetReturnArticleUrl = ({
  config,
  isMiraklOrderReturnAvailable,
  orderId,
  subOrder,
}: {
  config: PublicGlobalConfig
  isMiraklOrderReturnAvailable?: boolean
  orderId: string
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2
}): string => {
  const isMarketplace = userSubOrderAccessorIsMarketplaceOrder(subOrder)
  const isReturnable = userSubOrderAccessorIsSubOrderReturnable(subOrder)

  // Marketplace orders that have been dispatched should go to the refund page
  if (
    isMiraklOrderReturnAvailable &&
    subOrder.enrichedStatus === UserSubOrder1EnrichedStatusEnum.Dispatched &&
    subOrder.subOrderId
  ) {
    return urlResolverGetRefundOrder(config, orderId, subOrder.subOrderId)
  }

  if (isReturnable && subOrder.totalAmount) {
    return urlResolverGetHelpWithMyOrderBySubOrderId(config, orderId, {
      isMarketplace,
      returnOrder: true,
      subOrderId: subOrder.subOrderId ?? '',
    })
  }

  return urlResolverGetOrderQuestionsReturnItemPage(
    config,
    orderId,
    subOrder.subOrderId ?? '',
  )
}
